import React from "react";
import { InputPhoneNumber, countriesLocaleData, COUNTRY_CODE_DEFAULT, FORMATED_NUMBER_DEFAULT } from "../forms/components/InputPhoneNumber";

export const useInputPhoneNumber = (props) => {
    const [selectedCountryPhoneNumberISOCode, setSelectedCountryCode] = React.useState(COUNTRY_CODE_DEFAULT);
    const [formattedNumber, setFormattedNumber] = React.useState(FORMATED_NUMBER_DEFAULT);

    const countriesLocale = props?.countriesLocale || countriesLocaleData;

    const InputPhoneNumberComponent = (props) => {
        return (
            <InputPhoneNumber 
                {...props}
                countriesLocale={countriesLocale}
                formattedNumber={formattedNumber}
                setFormattedNumber={setFormattedNumber}
                selectedCountryCode={selectedCountryPhoneNumberISOCode}
                setSelectedCountryCode={setSelectedCountryCode}
            />
        )
    }

    return {
        selectedCountryPhoneNumberISOCode,
        InputPhoneNumberComponent
    }
}
